import React from "react";
import Close from "../../assets/img/closes.png";
import Menu from "./Menu";

const MobileLinksPopup = ({ onClose }) => {
  return (
    <>
      <div className={"loader"}>
        <div style={{ background: "none" }} className={"prtitle w-100 h-100"}>
          <div className="container-box">
            <div onClick={() => onClose()} className="close-button">
              <img src={Close} alt="" />
            </div>
            <div className="links">
              <Menu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileLinksPopup;
